import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=3faee970&lang=scss"
import "./App.vue?vue&type=style&index=1&id=3faee970&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=2&id=3faee970&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.69.1_uglify-js@3.15.2_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3faee970"]])

export default __exports__